import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { CrudProvider } from '../../providers/crud/crud';
import { UtiltiyProvider } from '../../providers/utiltiy/utiltiy';
import { KlmrTakeTemplateAddPage } from '../klmr-take-template-add/klmr-take-template-add';
@IonicPage()
@Component({
  selector: 'page-klmr-take-template',
  templateUrl: 'klmr-take-template.html',
})
export class KlmrTakeTemplatePage {
  templateList:any = [];
  actionAllowed:boolean = false;
  constructor(public navCtrl: NavController, public navParams: NavParams, private api: CrudProvider, public utiltiy: UtiltiyProvider) {
  }

  ionViewDidLoad() {
    this.getPermission();
    console.log('ionViewDidLoad KlmrTakeTemplatePage');
    this.getMetaData();
  }

  async getMetaData(){
    this.utiltiy.startLoading();
   this.templateList = await this.getData();
   this.utiltiy.stopLoading();

  }

  async getData(){
    // formData.append("folder_name", "klmr");
    return this.api.get("/prestart/take_5/Add_Templates", false)
      .then((result: any) => {
        console.log("result", result)
        if (result.status) {
          return result.result;
        }else{
         return [];
        }
      }, err => {
        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
        return [];
      })

}

async deleteRecord(id) {
  let status = await this.utiltiy.showDialog();
  if (status) {
    this.deleteTemplate(id);
  }
  console.log("status", status);
}

deleteTemplate(id) {
  let formData: FormData = new FormData();
    formData.append("method_name", "delete_take_5_template");
    formData.append("id", id);
  this.api.post(`/prestart/take_5/Add_Templates`, false,formData)
    .then((result: any) => {
      console.log("result", result)
      this.utiltiy.stopLoading();
      if (result.status) {
        this.utiltiy.toaster(result.message);
        this.getMetaData();
      }

    }, err => {
      this.utiltiy.stopLoading();
      this.utiltiy.toaster(err.error.message);
    })
}

addTemplate(){
  this.navCtrl.push(KlmrTakeTemplateAddPage, { param: null,disabled:false });
}
updateTemplate(template){
  this.navCtrl.push(KlmrTakeTemplateAddPage, { param: template,disabled:false });
}

async getPermission(){
  this.actionAllowed =  await this.utiltiy.getPagePermission("klmr-fuel-rw");
 }

}



// WEBPACK FOOTER //
// ./src/pages/klmr-take-template/klmr-take-template.ts